import Icon from '@plone/volto/components/theme/Icon/Icon';
import { Pagination } from 'semantic-ui-react';

import paginationLeftSVG from '@plone/volto/icons/left-key.svg';
import paginationRightSVG from '@plone/volto/icons/right-key.svg';

const BlockPagination = ({
  totalPages = 0,
  currentPage = 1,
  isEditMode,
  listingRef,
  onPaginationChange,
  prevBatch,
  nextBatch,
}) => {
  if (totalPages === 0) return null;
  return (
    <div className="pagination-wrapper">
      <Pagination
        aria-label="Navegação por páginas"
        activePage={currentPage}
        totalPages={totalPages}
        onPageChange={(e, { activePage }) => {
          !isEditMode &&
            listingRef.current.scrollIntoView({ behavior: 'smooth' });
          onPaginationChange(e, { activePage });
        }}
        firstItem={null}
        lastItem={null}
        prevItem={{
          content: (
            <>
              <span className="sr-only">Página anterior</span>
              <Icon name={paginationLeftSVG} size="18px" aria-hidden="true" />
            </>
          ),
          icon: true,
          className: !prevBatch ? 'disabled' : null,
          tabIndex: !prevBatch ? -1 : 0,
        }}
        nextItem={{
          content: (
            <>
              <span className="sr-only">Próxima página</span>
              <Icon name={paginationRightSVG} size="18px" aria-hidden="true" />
            </>
          ),
          icon: true,
          className: !nextBatch ? 'disabled' : null,
          tabIndex: !nextBatch ? -1 : 0,
        }}
      />
    </div>
  );
};

export default BlockPagination;
